import React from 'react';
import { acceptedCardWithImages } from './AcceptedCardTypes';

function CustomerCard({ paymentMethod, selected, onSelect }) {

    const cardType = acceptedCardWithImages.find(cardImage => (
        cardImage.type.toLowerCase() === paymentMethod.card.brand?.toLowerCase()
    ));

    return (
        <div className='d-flex mt-4 font-size-1'>
           
                <input type="radio" value={selected} checked={selected} onChange={(e) => {
                    e.value = e.target.checked;
                    onSelect(e);
                }} />
                <span className='mx-3'><img src={cardType?.src} /></span>

                <div>
                <div>
                    { cardType?.type } ending in { paymentMethod.card.last4 }
                </div>
                <div>
                    { paymentMethod.card.exp_month } / { paymentMethod.card.exp_year }
                    {/* paymentMethod.isExpired is set in PricingReducer.js */}
                    {
                        paymentMethod.isExpired &&
                        <span className='text-danger'>
                            &nbsp; Card expired, please update
                        </span>
                    }
                </div>
                </div>
        </div>
    )
}

export default CustomerCard;